import CloseIcon from "@mui/icons-material/Close";
import { Avatar, Box, Divider, Grid, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ViewDeliveryReportsDetails } from "../../slices/Reports/DeliveryReportSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";
import ViewIcon from "../Invitations/ViewIcon";

function DeliveryReportView({ heading, description, children, ...props }) {
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const [payload, setPayload] = useState({
    parcelImageObjectKey: props.rowData.parcelImageObjectKey
      ? props.rowData.parcelImageObjectKey
      : "",
    personImageObjectKey: props.rowData.personImageObjectKey
      ? props.rowData.personImageObjectKey
      : "",
    signatureObjectKey: props.rowData.signatureObjectKey
      ? props.rowData.signatureObjectKey
      : "",
  });
  const [parcelImagePresignedUrl, setParcelImagePresignedUrl] = useState("");
  const [personImagePresignedUrl, setPersonImagePresignedUrl] = useState("");
  const [signatureImagePresignedUrl, setSignatureImagePreSignedUrl] = useState(
    ""
  );

  const handleClickOpen = () => {
    if (
      !CommonUtil.isEmptyString(payload.parcelImageObjectKey) ||
      !CommonUtil.isEmptyString(payload.personImageObjectKey) ||
      !CommonUtil.isEmptyString(payload.signatureObjectKey)
    ) {
      loadData();
    }
    setOpen(true);
  };

  if (open) {
    setDiaLogBoxBlur(true);
  }

  const handleClose = () => {
    setOpen(false);
    setDiaLogBoxBlur(false);
  };

  const loadData = () => {
    const objectKeys = [
      payload.parcelImageObjectKey,
      payload.personImageObjectKey,
      payload.signatureObjectKey,
    ].filter((key) => !CommonUtil.isEmptyString(key));
    if (objectKeys.length === 0) {
      return;
    }
    const dto = { objectKeys };
    dispatch(ViewDeliveryReportsDetails(dto))
      .unwrap()
      .then((data) => {
        if (data.code === "STSI0000" || data.code === "STSW0001") {
          data.data.forEach((obj) => {
            switch (obj.objectKey) {
              case payload.parcelImageObjectKey:
                setParcelImagePresignedUrl(obj.preSignedUrl);
                break;
              case payload.personImageObjectKey:
                setPersonImagePresignedUrl(obj.preSignedUrl);
                break;
              case payload.signatureObjectKey:
                setSignatureImagePreSignedUrl(obj.preSignedUrl);
                break;
              default:
                break;
            }
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching delivery report details:", error);
      });
  };

  return (
    <>
      <Grid onClick={handleClickOpen}>
        <ViewIcon darkMode={darkMode} />
      </Grid>
      <Dialog
        open={open}
        fullWidth={true}
        PaperProps={{
          style: {
            borderRadius: "20px !important",
            minWidth: "50vw",
            backgroundColor: darkMode ? "rgb(14, 42, 65)" : "#fff",
            color: darkMode ? "#fff" : "#434547",
          },
        }}
        disableBackdropClick
        disableEscapeKeyDown
        BackdropProps={{
          style: {
            backdropFilter: "blur(5px)",
          },
        }}
      >
        <DialogTitle variant="h4">
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 15,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon onClick={handleClose} />
          </IconButton>
          <Typography
            style={{
              color: darkMode ? "#fff" : "black",
              fontSize: "20px",
              fontWeight: "450",
            }}
          >
            {props.title}
          </Typography>
        </DialogTitle>
        <Divider
          variant="middle"
          style={{
            background: darkMode
              ? "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box"
              : "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
            height: "1px",
            opacity: 0.5,
          }}
        />
        <DialogContent
          sx={{
            padding: "24px 10px 0px 24px",
          }}
        >
          <Grid
            container
            justifyContent="center"
            style={{ width: "100%" }}
            columnSpacing={2}
            rowSpacing={3}
          >
            <Box
              sx={{
                margin: "20px",
                borderStyle: "solid",
                borderRadius: "10px",
                padding: "35px",
                color: "#e9e9e9",
                opacity: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Avatar
                sx={{
                  width: 250,
                  height: 250,
                  border: "solid #FFFF",
                  borderWidth: "7px",
                }}
                alt={payload.parcelImageObjectKey}
                src={parcelImagePresignedUrl}
              />
              <Grid
                container
                justifyContent="center"
                sx={{
                  color: "#C3C5C7",
                  opacity: 1,
                  fontSize: "24px",
                  paddingTop: "34px",
                }}
              >
                {t("PERCEL_IMAGE")}
              </Grid>
            </Box>
            {signatureImagePresignedUrl && (
              <Box
                sx={{
                  margin: "20px",
                  borderStyle: "solid",
                  borderRadius: "10px",
                  padding: "35px",
                  color: "#e9e9e9",
                  opacity: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Avatar
                  sx={{
                    width: 250,
                    height: 250,
                    border: "solid #FFFF",
                    borderWidth: "7px",
                    "& img": {
                      objectFit: "contain",
                    },
                  }}
                  alt={payload.signatureObjectKey}
                  src={signatureImagePresignedUrl}
                />
                <Grid
                  container
                  justifyContent="center"
                  sx={{
                    color: "#C3C5C7",
                    opacity: 1,
                    fontSize: "24px",
                    paddingTop: "34px",
                  }}
                >
                  {t("Signature")}
                </Grid>
              </Box>
            )}
          </Grid>
        </DialogContent>

      </Dialog>
    </>
  );
}

export default DeliveryReportView;
